<template>
  <div class="bottom-cart-goto-top d-flex flex-column gap-4 position-fixed">
    <b-link class="btn btn-secondary py-0 rounded-circle" @click.stop="goCart"><ClientOnly><i class="fa-solid fa-basket-shopping" title="Cart"></i></ClientOnly></b-link>
    <a class="btn btn-goto-top py-0 rounded-circle" href="#"><ClientOnly><i class="fa-solid fa-chevron-up" title="Goto top"></i></ClientOnly></a>
  </div>
</template>

<script>
import ClientOnly from "vue-client-only";
export default {
  name: "BackToTop",
  components: {
    ClientOnly
  },
  props: {
    text: {
      type: String,
      default: "Voltar ao topo",
    },
    visibleoffset: {
      type: [String, Number],
      default: 600,
    },
    visibleoffsetbottom: {
      type: [String, Number],
      default: 0,
    },
    right: {
      type: String,
      default: "30px",
    },
    bottom: {
      type: String,
      default: "60px",
    },
    scrollFn: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    const btnGoTop = document.querySelector('.btn-goto-top');
    window.addEventListener('scroll', function() {
      window.pageYOffset > 250
        ? btnGoTop.classList.add('opacity-100')
        : btnGoTop.classList.remove('opacity-100');
    });
    btnGoTop.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    window.smoothscroll = () => {
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  },
  methods: {
    /**
     * Catch window scroll event
     * @return {void}
     */
    catchScroll() {
      const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset);
      const pastBottomOffset =
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight - parseInt(this.visibleoffsetbottom);
      this.visible =
        parseInt(this.visibleoffsetbottom) > 0
          ? pastTopOffset && !pastBottomOffset
          : pastTopOffset;
      this.scrollFn(this);
    },
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop() {
      window.smoothscroll();
      this.$emit("scrolled");
    },
    goCart() {
      this.$router.push("/checkout/cart");
    },
  },
};
</script>